import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { finishAppStartup, getSeoPrerender } from './AppLoadingFallback';

export class PageErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    if (!this.props.section) finishAppStartup();
  }

  componentDidUpdate(previous) {
    if (previous.resetKey !== this.props.resetKey && this.state.failed) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const prerender = this.props.section ? null : getSeoPrerender();
    return <>
      <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
        <Alert severity="warning">Не удалось загрузить {this.props.section ? 'раздел' : 'страницу'}. Проверьте соединение и попробуйте ещё раз.</Alert>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
          <Button variant="contained" onClick={() => window.location.reload()} sx={{ borderRadius: '22px', bgcolor: 'var(--green-color)' }}>Обновить страницу</Button>
          {!this.props.section ? <Button component="a" href="/" sx={{ borderRadius: '22px', color: 'var(--braun-color)' }}>На главную</Button> : null}
        </Box>
      </Box>
      {prerender ? <div dangerouslySetInnerHTML={{ __html: prerender }} /> : null}
    </>;
  }
}

export default function RouteErrorBoundary({ children }) {
  const { pathname, search } = useLocation();
  return <PageErrorBoundary resetKey={pathname + search}>{children}</PageErrorBoundary>;
}
